export default __webpack_public_path__ + "static/media/absences.82a7699d.png";